export class ChangerAgenceEmployee {
    username:string;
    newBankId:string;
    newDepartementId:string;
    backupUsername:string;
  }